// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"775":"gsap","9508":"ScrollTrigger"}[chunkId] + "." + {"775":"52b70335121799b93be2","9508":"d1b640a830ee9c2b02fc"}[chunkId] + ".js";
};